import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { AffiliateProfileResponseDto, ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class getAffiliateProfile extends IRequestCommand<IGetAffiliateProfileResponse, ErrorDetails, IGetAffiliateProfileCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'affiliateProfile/{id}';
    public override setParameters(parameters: IGetAffiliateProfileCommandParameters) {
        this._commandUrl = this._commandUrl.replace( '{id}',parameters.id.toString() );
  }
}

export interface IGetAffiliateProfileCommandParameters extends ICommandParameters {
    id?: number;
}

export interface IGetAffiliateProfileResponse extends AffiliateProfileResponseDto, ICommandResponse {}
